var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUiArrowTopRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.92174 1V8.3125C9.92174 8.4244 9.87733 8.5317 9.79823 8.6108C9.71913 8.6899 9.61184 8.7344 9.49994 8.7344C9.38804 8.7344 9.28074 8.6899 9.20164 8.6108C9.12244 8.5317 9.07804 8.4244 9.07804 8.3125V2.01953L0.795216 10.2953C0.716896 10.3736 0.610676 10.4176 0.499906 10.4176C0.389146 10.4176 0.282916 10.3736 0.204596 10.2953C0.126276 10.217 0.0822754 10.1108 0.0822754 10C0.0822754 9.8892 0.126276 9.78301 0.204596 9.70471L8.48034 1.42188H2.18741C2.07552 1.42188 1.96822 1.37743 1.8891 1.29831C1.80998 1.21919 1.76554 1.11189 1.76554 1C1.76554 0.888115 1.80998 0.780815 1.8891 0.701695C1.96822 0.622575 2.07552 0.578135 2.18741 0.578125H9.49994C9.61184 0.578135 9.71913 0.622575 9.79823 0.701695C9.87733 0.780815 9.92174 0.888115 9.92174 1Z",
    fill: "#B84F1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiArrowTopRight);
export default __webpack_public_path__ + "static/media/ui-arrow-top-right.141ffbb06fdbd7512c9b55e9cec63d1a.svg";
export { ForwardRef as ReactComponent };